import { Auth } from 'aws-amplify';
import jwt from 'jwt-decode';
import jwtDecode from 'jwt-decode';

export const getAccessControl = async () => {
  const encryptedToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const jwtToken = jwt(encryptedToken);
  const accessLevels = JSON.parse(jwtToken['custom:permissions']);
  return accessLevels;
};

export const getUserLevel = async () => {
  const encryptedToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const jwtToken = jwt(encryptedToken);
  const custMetaData = JSON.parse(jwtToken['custom:meta_data']);
  return custMetaData.role;
};

export const getCustomRoleControl = async () => {
  const encryptedToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const jwtToken = jwt(encryptedToken);
  const customRole = JSON.parse(jwtToken['custom:roles']);
  return customRole;
};

export const decodeJWT = (token) => {
  try {
    if (token) {
      return jwtDecode(token);
    }

    return null;
  } catch (error) {
    console.error('Error decode JWT data', error);
  }
};
